<div class="notification has-text-centered" *ngIf="showStrip">
    <p>{{ update }}</p>
</div>